import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { Withdraw, Dictionary, ContributionTypesEnum, ContributionSubTypesEnum, Contribution, FinancialReturn, SavingScheduleDate, Parameter, Employee, PeriodTypeEnum, LoanStatus } from '@akiba/models_bimbo';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { MatDialog } from '@angular/material';
import { CancelConfirmDialogComponent } from 'projects/bimbo/src/app/dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { take } from 'rxjs/operators';
import { ValidatorFn, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-ps-withdraw',
  templateUrl: './ps-withdraw.component.html',
  styleUrls: ['./ps-withdraw.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PsWithdrawComponent implements OnInit {

  //////////////////////////////////////
  permanentSavingParameter: Parameter | null = null;
  //////////////////////////////////////
  currentEmployee: Employee;
  //////////////////////////////////////

  showTotalWithdraw: boolean;
  loadWithdraw: boolean = false;

  showParcialWithdraw: boolean;
  withdraw: Withdraw = new Withdraw();
  private _financialReturn = 0;

  suraReturnTotal = 0;
  otherReturnTotal = 0;
  loanAmountListPending: number = 0;
  interest: number = 0;
  idPendingList: string = '';
  loanPendingList: any;
  showMatProgress: boolean = false;

  @Input() contentLocation: AppState;
  constructor(public logicService: LogicService, public dialog: MatDialog, private dataSource: DataSourceService, private authService: AuthenticationService) {
    this.showTotalWithdraw = true;
    this.showParcialWithdraw = false;

    const parameters = this.logicService.dataManager.parameterDataLoader.parameters ? this.logicService.dataManager.parameterDataLoader.parameters : [];

    this.currentEmployee = this.logicService.dataManager.proxyDataLoader.employee ? this.logicService.dataManager.proxyDataLoader.employee : this.logicService.dataManager.principalDataLoader.employee;
    this.permanentSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.permanentSaving).find(e => e.savingParameterAppliesTo(this.currentEmployee));

  }

  async ngOnInit() {

    const c1 = await this.dataSource.loadEmployeeContributions(ContributionTypesEnum.CAL, this.currentEmployee.workInformation.employeeNumber).pipe(take(1)).toPromise();
    const c2 = await this.dataSource.loadEmployeeContributions(ContributionSubTypesEnum.CAL_SURA, this.currentEmployee.workInformation.employeeNumber).pipe(take(1)).toPromise();

    const contributionArray: Array<Contribution> = c1.map((rec: any) => new Contribution(rec));
    const contributionArrayCAL_R: Array<Contribution> = c1.map((rec: any) => new Contribution(rec)).filter(e => e.subType === ContributionSubTypesEnum.CAL_DR || e.subType === ContributionSubTypesEnum.CAL_DRE);
    const contributionArrayCAL: Array<Contribution> = this.currentEmployee.permanentSavingsData.map((rec: any) => new Contribution(rec)).filter(e => e.subType !== ContributionSubTypesEnum.CAL_DR && e.subType !== ContributionSubTypesEnum.CAL_DRE);
    const t1 = contributionArrayCAL.map(r => r.investmentReturn + r.loanPerformance).reduce((p, n) => p + n, 0);

    const contributionSuraArray: Array<FinancialReturn> = c2.map((rec: any) => new FinancialReturn(rec));

    this.suraReturnTotal = contributionSuraArray.map(x => x.amount).reduce((p, n) => p + n, 0);
    const resultRe = contributionArrayCAL_R.map(x => x.investmentReturn).reduce((p, n) => p + n, this.suraReturnTotal);


    this._financialReturn = resultRe + t1;
    // this.otherReturnTotal = contributionArray.map(x => x && x.investmentReturn ? x.investmentReturn : 0).reduce((p, n) => p + n, 0);
    this.otherReturnTotal = this._financialReturn - this.suraReturnTotal;

    const loanListPending = await this.loanActiveInListPending();

    loanListPending.map(e => {

      this.loanAmountListPending = e.sumaPaids;
      this.interest = e.interest;
      this.idPendingList = e.idPendingList;
      this.loanPendingList = e.loan;
    });

    if (this.totalAmountToWithdraw >= 0) {
      this.loadWithdraw = true;
    } else {
      this.loadWithdraw = false;

    }

  }

  /**
 * funcion para regresar el prestamo activo en colaboradores en lista de espera
 */
  async loanActiveInListPending() {
    const loans = await this.dataSource.loadLoanActiveListPending(this.currentEmployee.workInformation.employeeNumber, 500, 500);
    let restructuredID: string = '';
    let sumaPaids: number = 0;
    let interest: number = 0;
    let loan: number = 0;
    let interestPercentage: number = 0;
    let pendingLoan = 0;
    let loadLoan: any;
    let loanListPending;
    let activePendingList: Array<any> = [];
    let interestType = '';
    activePendingList = loans.filter(e => e.active === true && e.type === 'permanent' && (e.status == 'active_pending' || e.status == 'review'));

    if (loans.length > 1 && activePendingList.length > 0) {

      loanListPending = loans.filter(e => e.active === true && e.type === 'permanent' && (e.status != 'active_pending' || e.status != 'review'));

      if (loanListPending.length > 0) {
        loanListPending.map(e => restructuredID = e.restructuredID);
      }

      if (restructuredID != '') {
        loadLoan = await this.dataSource.loadLoan(restructuredID).pipe(take(1)).toPromise().catch(error => {
          console.log(error);
          return [];
        });
        if (loadLoan.status != 'paid' && loadLoan.status != 'withdraw' && loadLoan.status != 'caducado') {
          const cretedAt = loadLoan.createdAt.toDate();
          interestType = loadLoan.interestType;
          //loan = loadLoan.requestedNumberOfPayments;
          interestPercentage = loadLoan.interestPercentage;
          const suma = await this.dataSource.loanActiveInPendingList(this.currentEmployee.workInformation.employeeNumber, cretedAt, interestType);
          suma.map(e => {

            sumaPaids = e.sumPayments < loadLoan.requestedAmount ? loadLoan.requestedAmount - e.sumPayments : 0;
            pendingLoan = e.subType === "PCAH" ? e.sumPayments : 0;

            if (loadLoan.requestedNumberOfPayments === e.longPayments || loadLoan.requestedNumberOfPayments < e.longPayments) {
              loan = 0;
            } else {
              loan = (loadLoan.requestedNumberOfPayments - e.longPayments) - 1;
            }
          });
        }
      }
    }

    if (interestType != 'fixed') {
      interest = loan * pendingLoan * interestPercentage;
    } else {
      interest = 0;
    }

    let result = [{ sumaPaids: sumaPaids, interest: interest, idPendingList: restructuredID, loan: loadLoan }];
    result = [{ sumaPaids: sumaPaids, interest: interest, idPendingList: restructuredID, loan: loadLoan }];
    return result;
  }


  totalWithdraw() {
    this.showTotalWithdraw = true;
    this.showParcialWithdraw = false;
  }

  parcialWithdraw() {
    this.showTotalWithdraw = false;
    this.showParcialWithdraw = true;
  }

  get employeeHasLoans(): boolean {

    return this.currentEmployee.permanentSavingsLoan !== null && this.currentEmployee.permanentSavingsLoan !== undefined;

  }

  get pendingLoanTotal(): number {
    if (this.loanAmountListPending > 0) {
      const pending = this.loanAmountListPending;
      return pending;
    } else if (this.currentEmployee.permanentSavingsLoan && this.currentEmployee.permanentSavingsLoan != null) {
      if (this.currentEmployee.permanentSavingsLoan.status != "review" && this.currentEmployee.permanentSavingsLoan.status != "active_pending") {

        const al = this.currentEmployee.permanentSavingsLoan;
        const pending = al.scheduleDates.values().filter(element => !element.paid).map(element => element.capital).reduce(((prev, next) => next ? prev + next : prev), 0);
        return pending;
      }

    }
    return 0;
  }

  get remainingPayments(): number {
    if (this.loanAmountListPending > 0) {
      const pending = this.loanAmountListPending;
      return pending;
    } else if (this.currentEmployee.permanentSavingsLoan && this.currentEmployee.permanentSavingsLoan.status != "review" || this.currentEmployee.permanentSavingsLoan.status != "active_pending") {
      const al = this.currentEmployee.permanentSavingsLoan;
      if (al) {
        const pending = al.scheduleDates.values().filter(element => !element.paid).length;
        return pending;
      }
    }

    return 0;

  }

  get remainingAmountPayments(): number {

    if (!this.currentEmployee.permanentSavingsLoan) {
      return 0;
    } else if (this.currentEmployee.permanentSavingsLoan && this.currentEmployee.permanentSavingsLoan.status != "review" && this.currentEmployee.permanentSavingsLoan.status != "active_pending") {
      const pendingAmount = this.currentEmployee.permanentSavingsLoan.scheduleDates.values().filter(element => !element.paid).map(element => element.capital).reduce(((prev, next) => prev + next), 0);
      return pendingAmount;
    } else {
      const pendingAmount = this.currentEmployee.permanentSavingsLoan.scheduleDates.values().filter(element => !element.paid).map(element => element.capital).reduce(((prev, next) => prev + next), 0);
      return pendingAmount;

    }


  }

  get prepaymentInterest(): number {

    let calc = 0;
    if (this.loanAmountListPending > 0 && this.interest > 0) {
      calc = this.interest;

    } else if (this.currentEmployee.permanentSavingsLoan && this.currentEmployee.permanentSavingsLoan.status != "review" &&
      this.currentEmployee.permanentSavingsLoan.status != "active_pending" && this.currentEmployee.permanentSavingsLoan.interestType != "fixed") {
      const ip = this.currentEmployee.permanentSavingsLoan ? this.currentEmployee.permanentSavingsLoan.interestPercentage : 0;
      const remAmount = this.pendingLoanTotal;
      const remPayments = (this.remainingPayments - 1);
      const remInt = ip;
      calc = (remAmount * remInt * remPayments);
    }

    return calc;

  }

  get financialReturn(): number {
    return this._financialReturn;
  }

  get totalAmountToWithdraw(): number {


    if (this.employeeHasLoans) {
      const loanTotal = this.pendingLoanTotal - this.prepaymentInterest;
      const savingTotal = this.currentSavingTotal + this._financialReturn;
      return savingTotal - loanTotal;
    } else {
      return this.currentSavingTotal;
    }

  }

  get totalAmountToWithdrawForBimbo(): number {
    const total = (this.currentEmployee.permanentSavings.total + this.currentEmployee.permanentSavings.totalExtras) - this.currentEmployee.permanentSavings.totalWithdrawals;
    return total;
  }

  get currentSavingTotal(): number {
    const t = (this.currentEmployee.permanentSavings.total + this.currentEmployee.permanentSavings.totalExtras) - this.currentEmployee.permanentSavings.totalWithdrawals;
    return t;
  }

  get totalWithdrawSum(): number {
    return this.currentSavingTotal + this.financialReturn;
  }

  saveTotalWithdraw() {

    this.withdraw.uid = this.currentEmployee.uid;
    this.withdraw.withdrawID = this.withdraw.date.getTime().toString();
    this.withdraw.financialReturnAmount = this.otherReturnTotal > 0 ? Number(this.otherReturnTotal.toFixed(2)) : 0;
    this.withdraw.suraFinancialReturnAmount = this.suraReturnTotal > 0 ? Number(this.suraReturnTotal.toFixed(2)) : 0;

    if (this.currentSavingTotal < 1) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El monto del retiro debe de ser mayor a 0.00 pesos.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.currentEmployee.permanentSavingsLoan && this.currentEmployee.permanentSavingsLoan != null && this.currentEmployee.permanentSavingsLoan.status != "review" && this.currentEmployee.permanentSavingsLoan.status != "active_pending") {
      if (this.totalAmountToWithdrawForBimbo < this.remainingAmountPayments) {
        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'No se puede procesar tu solicitud debido a que el total de tu<br>ahorro no cubre el total del préstamo activo',
            close: 'Aceptar'
          }
        });
        return false;
      }

      this.withdraw.type = 'totalWithdrawWithLoan';
      this.withdraw.typeID = 1;
      this.withdraw.loan = this.currentEmployee.permanentSavingsLoan;
      this.withdraw.prepaymentInterest = this.prepaymentInterest;
      this.withdraw.remainingLoanAmount = Number(this.pendingLoanTotal.toFixed(2));

    } else if (this.loanAmountListPending > 0) {
      const pendingLoantotal = Number(this.pendingLoanTotal.toFixed(2));
      if (this.totalAmountToWithdrawForBimbo < pendingLoantotal) {
        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'No se puede procesar tu solicitud debido a que el total de tu<br>ahorro no cubre el total del préstamo activo',
            close: 'Aceptar'
          }
        });
        return false;
      }

      this.withdraw.type = 'totalWithdrawWithLoan';
      this.withdraw.typeID = 1;
      this.withdraw.loan = this.loanPendingList;
      this.withdraw.prepaymentInterest = this.prepaymentInterest;
      this.withdraw.remainingLoanAmount = Number(this.pendingLoanTotal.toFixed(2));
    } else {

      this.withdraw.type = 'totalWithdraw';
      this.withdraw.typeID = 2;
      this.withdraw.loan = null;

    }

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea retirar el monto total de la caja de ahorro?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(async result => {

      if (result) {

        this.showMatProgress = result;
        this.withdraw.active = true;
        this.withdraw.processed = false;
        this.withdraw.amountToWithdraw = Number(this.totalAmountToWithdrawForBimbo.toFixed(2));
        //this.currentEmployee.permanentSavings.withdraws.clear();
        this.currentEmployee.permanentSavings.withdraws.add(this.withdraw.withdrawID, this.withdraw);
        let v = this.currentEmployee.permanentSavings.paidDates.values().find(element => !element.paid);


        if (v !== undefined) {
          v.withdraw = this.withdraw.amountToWithdraw;
        } else if (v === undefined) {
          v = new SavingScheduleDate();
          v.withdraw = this.withdraw.amountToWithdraw;
        }

        const psObject = Object.assign({}, this.currentEmployee.permanentSavings.toAny());
        delete psObject._paidDatesForDisplay;
        await this.logPermanentLoanMovements(this.withdraw);

        this.dataSource.updatePermanentSavings(this.currentEmployee.uid, psObject).then(async () => {

          if (this.currentEmployee.permanentSavingsLoan) {

            let id: string = '';

            if (this.currentEmployee.permanentSavingsLoan.status != "review" && this.currentEmployee.permanentSavingsLoan.status != "active_pending") {
              id = this.currentEmployee.permanentSavingsLoan.loanID;
              this.currentEmployee.permanentSavingsLoan.status = LoanStatus.WITHDRAW;

            } else if (this.currentEmployee.permanentSavingsLoan.status == "review" || this.currentEmployee.permanentSavingsLoan.status == "active_pending" && this.idPendingList !== this.currentEmployee.permanentSavingsLoan.loanID) {
              id = this.idPendingList;
              this.currentEmployee.permanentSavingsLoan.loanID = this.idPendingList;
              this.currentEmployee.permanentSavingsLoan.status = LoanStatus.WITHDRAW;

            }

            psObject.active = false;
            this.currentEmployee.permanentSavingsLoan.prepaymentInterest = this.prepaymentInterest;

            // const loansArray = Object.keys(transport).map(key => transport[key]).filter(obj => obj);
            if (id != '') {
              this.dataSource.markWithdrawLoan(this.currentEmployee.permanentSavingsLoan.loanID, psObject).then(() => {
                this.dialog.open(InfoDialogComponent, {
                  data: {
                    message: 'Su solicitud se ha realizado con éxito',
                    close: 'Aceptar'
                  }
                });

                this.contentLocation.tabIndex = 0;
                this.contentLocation.detailIndex = null;
                this.contentLocation.contentIndex = 0;
                this.withdraw = new Withdraw();
              }).catch(error => {

                this.dialog.open(InfoDialogComponent, {
                  data: {
                    message: 'El proceso no se pudo realizar, por favor avisa a los encargados.',
                    close: 'Aceptar'
                  }
                });

              });
            } else {
              // tiene un prestamo en lista de espera pero no es reestructura
              this.contentLocation.tabIndex = 0;
              this.contentLocation.detailIndex = null;
              this.contentLocation.contentIndex = 0;
              this.withdraw = new Withdraw();
              this.dialog.open(InfoDialogComponent, {
                data: {
                  message: 'Su solicitud se ha realizado con éxito.',
                  close: 'Aceptar'
                }
              });


            }
            //

          } else {

            this.dialog.open(InfoDialogComponent, {
              data: {
                message: 'Su solicitud se ha realizado con éxito',
                close: 'Aceptar'
              }
            });

            this.contentLocation.detailIndex = 0;

          }

        }).catch(error => {

          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'El proceso no se pudo realizar, por favor avisa a los encargados.',
              close: 'Aceptar'
            }
          });

        });

      }

    });

  }

  savePartialWithdraw() {
    this.withdraw.financialReturnAmount = this.otherReturnTotal > 0 ? Number(this.otherReturnTotal.toFixed(2)) : 0;
    this.withdraw.suraFinancialReturnAmount = this.suraReturnTotal > 0 ? Number(this.suraReturnTotal.toFixed(2)) : 0;

    if (this.withdraw.amountToWithdraw < 1) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El monto del retiro debe de ser mayor a 0.00 pesos.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.withdraw.amountToWithdraw >= this.currentSavingTotal - 100) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El monto del retiro es mayor o igual a su ahorro, si desea retirar el total de su ahorro seleccione la opción de retiro total.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.currentEmployee.permanentSavingsLoan && this.currentEmployee.permanentSavingsLoan.status != "review" && this.currentEmployee.permanentSavingsLoan.status != 'active_pending') {

      this.withdraw.type = 'partialWithdrawWithLoan';
      this.withdraw.typeID = 3;
      this.withdraw.loan = this.currentEmployee.permanentSavingsLoan;

      if (this.withdraw.amountToWithdraw >= this.currentSavingTotal - 100) {
        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'El monto del retiro es mayor o igual a su ahorro, si desea retirar el total de su ahorro seleccione la opción de retiro total.',
            close: 'Aceptar'
          }
        });

        return;

      }
      if (this.withdraw.amountToWithdraw < this.remainingAmountPayments) {
        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'No se puede procesar tu solicitud debido a que el monto<br>no cubre el total del préstamo activo',
            close: 'Aceptar'
          }
        });
        return;
      }

    } else if (this.loanAmountListPending > 0) {

      this.withdraw.type = 'partialWithdrawWithLoan';
      this.withdraw.typeID = 3;
      this.withdraw.loan = this.loanPendingList;

      if (this.withdraw.amountToWithdraw < this.loanAmountListPending) {
        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'No se puede procesar tu solicitud debido a que el monto<br>no cubre el total del préstamo activo',
            close: 'Aceptar'
          }
        });
        return;
      }
    } else {
      this.withdraw.type = 'partialWithdraw';
      this.withdraw.typeID = 4;
      this.withdraw.loan = null;
    }

    this.withdraw.withdrawID = this.withdraw.date.getTime().toString();
    this.withdraw.uid = this.currentEmployee.uid;
    this.withdraw.prepaymentInterest = this.prepaymentInterest;
    this.withdraw.remainingLoanAmount = Number(this.pendingLoanTotal.toFixed(2));

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: `¿Esta seguro(a) que desea solicitar un retiro a la caja de Ahorro por un monto de ${this.withdraw.amountToWithdraw.toFixed(2)} pesos?`,
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(async result => {

      if (result) {
        this.showMatProgress = result;

        // this.currentEmployee.permanentSavings.withdraws.clear();
        this.withdraw.active = true;
        this.withdraw.processed = false;

        this.currentEmployee.permanentSavings.withdraws.add(this.withdraw.withdrawID, this.withdraw);
        let v = this.currentEmployee.permanentSavings.paidDates.values().find(element => !element.paid);

        if (v !== undefined) {
          v.withdraw = this.withdraw.amountToWithdraw;
        } else if (v === undefined) {
          v = new SavingScheduleDate();
          v.withdraw = this.withdraw.amountToWithdraw;
        }

        const psObject = this.currentEmployee.permanentSavings.toAny();
        delete psObject._paidDatesForDisplay;
        const r = this.currentSavingTotal - this.withdraw.amountToWithdraw;
        await this.logPermanentLoanMovements(this.withdraw);
        this.dataSource.updatePermanentSavings(this.currentEmployee.uid, psObject).then(async () => {

          if (this.currentEmployee.permanentSavingsLoan) {
            let id: string = '';

            if (this.currentEmployee.permanentSavingsLoan.status != "review" && this.currentEmployee.permanentSavingsLoan.status != "active_pending") {
              id = this.currentEmployee.permanentSavingsLoan.loanID;
              this.currentEmployee.permanentSavingsLoan.status = LoanStatus.WITHDRAW;

            } else if (this.currentEmployee.permanentSavingsLoan.status == "review" || this.currentEmployee.permanentSavingsLoan.status == "active_pending" && this.idPendingList !== this.currentEmployee.permanentSavingsLoan.loanID) {
              id = this.idPendingList;
              this.currentEmployee.permanentSavingsLoan.loanID = this.idPendingList;
              this.currentEmployee.permanentSavingsLoan.status = LoanStatus.WITHDRAW;
            }

            psObject.active = false;
            this.currentEmployee.permanentSavingsLoan.prepaymentInterest = this.prepaymentInterest;

            //const loansArray = Object.keys(transport).map(key => transport[key]).filter(obj => obj);

            if (id != '') {
              this.dataSource.markWithdrawLoan(this.currentEmployee.permanentSavingsLoan.loanID, psObject).then(() => {
                this.contentLocation.tabIndex = 0;
                this.contentLocation.detailIndex = null;
                this.contentLocation.contentIndex = 0;

                this.dialog.open(InfoDialogComponent, {
                  data: {
                    message: 'Su solicitud se ha realizado con éxito.',
                    close: 'Aceptar'
                  }
                });

                this.contentLocation.detailIndex = 0;

              }).catch(error => {

                this.dialog.open(InfoDialogComponent, {
                  data: {
                    message: 'El proceso no se pudo realizar, por favor avisa a los encargados.',
                    close: 'Aceptar'
                  }
                });

              });

            } else {
              // tiene un prestamo en lista de espera pero no es reestructura
              this.contentLocation.tabIndex = 0;
              this.contentLocation.detailIndex = null;
              this.contentLocation.contentIndex = 0;
              this.withdraw = new Withdraw();
              this.dialog.open(InfoDialogComponent, {
                data: {
                  message: 'Su solicitud se ha realizado con éxito.',
                  close: 'Aceptar'
                }
              });


            }

          } else {

            this.contentLocation.tabIndex = 0;
            this.contentLocation.detailIndex = null;
            this.contentLocation.contentIndex = 0;
            this.withdraw = new Withdraw();
            this.dialog.open(InfoDialogComponent, {
              data: {
                message: 'Su solicitud se ha realizado con éxito.',
                close: 'Aceptar'
              }
            });

            this.contentLocation.detailIndex = 0;

          }

        }).catch(error => {

          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'El proceso no se pudo realizar, por favor avisa a los encargados.',
              close: 'Aceptar'
            }
          });

        });

      }

    });
  }


  async logPermanentLoanMovements(withdrawsNew: any) {

    let withdraws: Array<any> = [];
    let date = new Date();

    withdraws.push(withdrawsNew.toAny());

    const paramLogs = {
      employeeNumber: this.currentEmployee.permanentSavings.employeeRef.employeeNumber,
      modificationDate: date,
      withdraws: withdraws,
      registerFor: this.authService.authEmployee.uid
    }
    //guardar en logs 
    await this.dataSource.saveLogPermanentLoanMovements(paramLogs).catch(error => {
      console.log(error);
    });
  }

  ////////////////////////////////////////////////////////

  currencyInputChanged(value: string) {

    const num = value.replace(/[$,]/g, '');
    const intValue = Number(num);
    return intValue;

  }

  customValidator(min: number, max: number): ValidatorFn {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

      let result: any | null = null;

      if (!control.value) {
        return result;
      }

      const num = control.value ? control.value.replace(/[$,]/g, '') : 0;
      const intValue = Number(num);

      if (isNaN(intValue)) {
        result = { min: true };
      } else if (intValue < min) {
        result = { min: true };
      } else if (intValue > max) {
        result = { max: true };
      }

      return result;

    };

  }

  ////////////////////////////////////////////////////////

  cancel(tabIndex: number, detailIndex: number | null) {

    const cancelRegistration = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Confirmar'
      }
    });

    cancelRegistration.afterClosed().subscribe(result => {
      if (result) {
        this.contentLocation.tabIndex = tabIndex;
        this.contentLocation.detailIndex = detailIndex;
        this.contentLocation.contentIndex = 0;
        this.withdraw = new Withdraw();
      }
    });

  }

  ngOnDestroy() {
    this.withdraw = new Withdraw();
  }


}